// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "button[data-v-47d2ebce] {\n  padding: 1px 12px;\n}", "",{"version":3,"sources":["webpack://assets/modules/invoice/components/buttons/send-email-invoice-button.vue","webpack://send-email-invoice-button.vue"],"names":[],"mappings":"AACA;EACE,iBAAA;ACAF","sourcesContent":["\nbutton {\n  padding: 1px 12px;\n}\n","button {\n  padding: 1px 12px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
